/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ConnectNinjaOne200Response,
    ConnectNinjaOne200ResponseFromJSON,
    ConnectNinjaOne200ResponseToJSON,
} from '../models/ConnectNinjaOne200Response';
import {
    type ConnectNinjaOneRequest,
    ConnectNinjaOneRequestFromJSON,
    ConnectNinjaOneRequestToJSON,
} from '../models/ConnectNinjaOneRequest';
import {
    type DeleteReseller200Response,
    DeleteReseller200ResponseFromJSON,
    DeleteReseller200ResponseToJSON,
} from '../models/DeleteReseller200Response';
import {
    type GetAutotaskCompanies200Response,
    GetAutotaskCompanies200ResponseFromJSON,
    GetAutotaskCompanies200ResponseToJSON,
} from '../models/GetAutotaskCompanies200Response';
import {
    type GetAutotaskCompaniesRequest,
    GetAutotaskCompaniesRequestFromJSON,
    GetAutotaskCompaniesRequestToJSON,
} from '../models/GetAutotaskCompaniesRequest';
import {
    type GetAutotaskTicketFields200Response,
    GetAutotaskTicketFields200ResponseFromJSON,
    GetAutotaskTicketFields200ResponseToJSON,
} from '../models/GetAutotaskTicketFields200Response';
import {
    type GetIntegrationsConfig200Response,
    GetIntegrationsConfig200ResponseFromJSON,
    GetIntegrationsConfig200ResponseToJSON,
} from '../models/GetIntegrationsConfig200Response';
import {
    type GetNinjaOneOrganizations200Response,
    GetNinjaOneOrganizations200ResponseFromJSON,
    GetNinjaOneOrganizations200ResponseToJSON,
} from '../models/GetNinjaOneOrganizations200Response';
import {
    type GetNinjaOneOrganizationsRequest,
    GetNinjaOneOrganizationsRequestFromJSON,
    GetNinjaOneOrganizationsRequestToJSON,
} from '../models/GetNinjaOneOrganizationsRequest';
import {
    type GetTehtrisStatuses200Response,
    GetTehtrisStatuses200ResponseFromJSON,
    GetTehtrisStatuses200ResponseToJSON,
} from '../models/GetTehtrisStatuses200Response';
import {
    type GetWellKnownEmailServices401Response,
    GetWellKnownEmailServices401ResponseFromJSON,
    GetWellKnownEmailServices401ResponseToJSON,
} from '../models/GetWellKnownEmailServices401Response';
import {
    type GetWellKnownEmailServices500Response,
    GetWellKnownEmailServices500ResponseFromJSON,
    GetWellKnownEmailServices500ResponseToJSON,
} from '../models/GetWellKnownEmailServices500Response';
import {
    type SetIntegrationEnabled200Response,
    SetIntegrationEnabled200ResponseFromJSON,
    SetIntegrationEnabled200ResponseToJSON,
} from '../models/SetIntegrationEnabled200Response';
import {
    type SetIntegrationEnabledRequest,
    SetIntegrationEnabledRequestFromJSON,
    SetIntegrationEnabledRequestToJSON,
} from '../models/SetIntegrationEnabledRequest';
import {
    type TestAutotaskConnection200Response,
    TestAutotaskConnection200ResponseFromJSON,
    TestAutotaskConnection200ResponseToJSON,
} from '../models/TestAutotaskConnection200Response';
import {
    type TestAutotaskConnectionRequest,
    TestAutotaskConnectionRequestFromJSON,
    TestAutotaskConnectionRequestToJSON,
} from '../models/TestAutotaskConnectionRequest';
import {
    type TestEmailForwarding200Response,
    TestEmailForwarding200ResponseFromJSON,
    TestEmailForwarding200ResponseToJSON,
} from '../models/TestEmailForwarding200Response';
import {
    type TestEmailForwardingRequest,
    TestEmailForwardingRequestFromJSON,
    TestEmailForwardingRequestToJSON,
} from '../models/TestEmailForwardingRequest';
import {
    type TestNinjaOneConnection200Response,
    TestNinjaOneConnection200ResponseFromJSON,
    TestNinjaOneConnection200ResponseToJSON,
} from '../models/TestNinjaOneConnection200Response';
import {
    type TestNinjaOneConnectionRequest,
    TestNinjaOneConnectionRequestFromJSON,
    TestNinjaOneConnectionRequestToJSON,
} from '../models/TestNinjaOneConnectionRequest';
import {
    type TestTehtrisConnection200Response,
    TestTehtrisConnection200ResponseFromJSON,
    TestTehtrisConnection200ResponseToJSON,
} from '../models/TestTehtrisConnection200Response';
import {
    type TestTehtrisConnectionRequest,
    TestTehtrisConnectionRequestFromJSON,
    TestTehtrisConnectionRequestToJSON,
} from '../models/TestTehtrisConnectionRequest';
import {
    type UpdateIntegrationsConfigRequest,
    UpdateIntegrationsConfigRequestFromJSON,
    UpdateIntegrationsConfigRequestToJSON,
} from '../models/UpdateIntegrationsConfigRequest';

export interface ConnectNinjaOneOperationRequest {
    /**
     * 
     */
    clientUUID: string;
    /**
     * 
     */
    connectNinjaOneRequest: ConnectNinjaOneRequest;
}

export interface DisconnectNinjaOneRequest {
    /**
     * 
     */
    clientUUID: string;
}

export interface GetAutotaskCompaniesOperationRequest {
    /**
     * 
     */
    clientUUID: string;
    /**
     * 
     */
    getAutotaskCompaniesRequest: GetAutotaskCompaniesRequest;
    /**
     * 
     */
    refresh?: GetAutotaskCompaniesOperationRefreshEnum;
}

export interface GetAutotaskTicketFieldsRequest {
    /**
     * 
     */
    clientUUID: string;
    /**
     * 
     */
    refresh?: GetAutotaskTicketFieldsRefreshEnum;
}

export interface GetIntegrationsConfigRequest {
    /**
     * 
     */
    clientUUID: string;
}

export interface GetNinjaOneOrganizationsOperationRequest {
    /**
     * 
     */
    clientUUID: string;
    /**
     * 
     */
    getNinjaOneOrganizationsRequest: GetNinjaOneOrganizationsRequest;
    /**
     * 
     */
    refresh?: GetNinjaOneOrganizationsOperationRefreshEnum;
}

export interface GetTehtrisStatusesRequest {
    /**
     * 
     */
    clientUUID: string;
    /**
     * 
     */
    refresh?: GetTehtrisStatusesRefreshEnum;
}

export interface SetIntegrationEnabledOperationRequest {
    /**
     * 
     */
    clientUUID: string;
    /**
     * 
     */
    setIntegrationEnabledRequest: SetIntegrationEnabledRequest;
}

export interface TestAutotaskConnectionOperationRequest {
    /**
     * 
     */
    clientUUID: string;
    /**
     * 
     */
    testAutotaskConnectionRequest: TestAutotaskConnectionRequest;
}

export interface TestEmailForwardingOperationRequest {
    /**
     * 
     */
    clientUUID: string;
    /**
     * 
     */
    testEmailForwardingRequest: TestEmailForwardingRequest;
}

export interface TestNinjaOneConnectionOperationRequest {
    /**
     * 
     */
    clientUUID: string;
    /**
     * 
     */
    testNinjaOneConnectionRequest: TestNinjaOneConnectionRequest;
}

export interface TestTehtrisConnectionOperationRequest {
    /**
     * 
     */
    clientUUID: string;
    /**
     * 
     */
    testTehtrisConnectionRequest: TestTehtrisConnectionRequest;
}

export interface UpdateIntegrationsConfigOperationRequest {
    /**
     * 
     */
    clientUUID: string;
    /**
     * 
     */
    updateIntegrationsConfigRequest: UpdateIntegrationsConfigRequest;
}

/**
 * 
 */
export class IntegrationsApi extends runtime.BaseAPI {

    /**
     * Creates request options for connectNinjaOne without sending the request
     */
    async connectNinjaOneRequestOpts(requestParameters: ConnectNinjaOneOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling connectNinjaOne().'
            );
        }

        if (requestParameters['connectNinjaOneRequest'] == null) {
            throw new runtime.RequiredError(
                'connectNinjaOneRequest',
                'Required parameter "connectNinjaOneRequest" was null or undefined when calling connectNinjaOne().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/integrations/ninjaone/connect`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConnectNinjaOneRequestToJSON(requestParameters['connectNinjaOneRequest']),
        };
    }

    /**
     * Exchange a NinjaOne authorization code for a user connection (required for ticket creation)
     */
    async connectNinjaOneRaw(requestParameters: ConnectNinjaOneOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConnectNinjaOne200Response>> {
        const requestOptions = await this.connectNinjaOneRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConnectNinjaOne200ResponseFromJSON(jsonValue));
    }

    /**
     * Exchange a NinjaOne authorization code for a user connection (required for ticket creation)
     */
    async connectNinjaOne(clientUUID: string, connectNinjaOneRequest: ConnectNinjaOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConnectNinjaOne200Response> {
        const response = await this.connectNinjaOneRaw({ clientUUID: clientUUID, connectNinjaOneRequest: connectNinjaOneRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for disconnectNinjaOne without sending the request
     */
    async disconnectNinjaOneRequestOpts(requestParameters: DisconnectNinjaOneRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling disconnectNinjaOne().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/integrations/ninjaone/disconnect`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Remove the NinjaOne user connection
     */
    async disconnectNinjaOneRaw(requestParameters: DisconnectNinjaOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConnectNinjaOne200Response>> {
        const requestOptions = await this.disconnectNinjaOneRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConnectNinjaOne200ResponseFromJSON(jsonValue));
    }

    /**
     * Remove the NinjaOne user connection
     */
    async disconnectNinjaOne(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConnectNinjaOne200Response> {
        const response = await this.disconnectNinjaOneRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAutotaskCompanies without sending the request
     */
    async getAutotaskCompaniesRequestOpts(requestParameters: GetAutotaskCompaniesOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getAutotaskCompanies().'
            );
        }

        if (requestParameters['getAutotaskCompaniesRequest'] == null) {
            throw new runtime.RequiredError(
                'getAutotaskCompaniesRequest',
                'Required parameter "getAutotaskCompaniesRequest" was null or undefined when calling getAutotaskCompanies().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/integrations/autotask/companies`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetAutotaskCompaniesRequestToJSON(requestParameters['getAutotaskCompaniesRequest']),
        };
    }

    /**
     * List the Autotask companies (customers) for the setup wizard. Optional credentials in the body allow loading before the config is saved.
     */
    async getAutotaskCompaniesRaw(requestParameters: GetAutotaskCompaniesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAutotaskCompanies200Response>> {
        const requestOptions = await this.getAutotaskCompaniesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAutotaskCompanies200ResponseFromJSON(jsonValue));
    }

    /**
     * List the Autotask companies (customers) for the setup wizard. Optional credentials in the body allow loading before the config is saved.
     */
    async getAutotaskCompanies(clientUUID: string, getAutotaskCompaniesRequest: GetAutotaskCompaniesRequest, refresh?: GetAutotaskCompaniesOperationRefreshEnum, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAutotaskCompanies200Response> {
        const response = await this.getAutotaskCompaniesRaw({ clientUUID: clientUUID, getAutotaskCompaniesRequest: getAutotaskCompaniesRequest, refresh: refresh }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAutotaskTicketFields without sending the request
     */
    async getAutotaskTicketFieldsRequestOpts(requestParameters: GetAutotaskTicketFieldsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getAutotaskTicketFields().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/integrations/autotask/fields`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Autotask ticket picklists (status, priority, queue, ticket type) - cached
     */
    async getAutotaskTicketFieldsRaw(requestParameters: GetAutotaskTicketFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAutotaskTicketFields200Response>> {
        const requestOptions = await this.getAutotaskTicketFieldsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAutotaskTicketFields200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Autotask ticket picklists (status, priority, queue, ticket type) - cached
     */
    async getAutotaskTicketFields(clientUUID: string, refresh?: GetAutotaskTicketFieldsRefreshEnum, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAutotaskTicketFields200Response> {
        const response = await this.getAutotaskTicketFieldsRaw({ clientUUID: clientUUID, refresh: refresh }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getIntegrationsConfig without sending the request
     */
    async getIntegrationsConfigRequestOpts(requestParameters: GetIntegrationsConfigRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getIntegrationsConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/integrations/`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get integrations configuration for a client (without sensitive data)
     */
    async getIntegrationsConfigRaw(requestParameters: GetIntegrationsConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetIntegrationsConfig200Response>> {
        const requestOptions = await this.getIntegrationsConfigRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetIntegrationsConfig200ResponseFromJSON(jsonValue));
    }

    /**
     * Get integrations configuration for a client (without sensitive data)
     */
    async getIntegrationsConfig(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetIntegrationsConfig200Response> {
        const response = await this.getIntegrationsConfigRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getNinjaOneOrganizations without sending the request
     */
    async getNinjaOneOrganizationsRequestOpts(requestParameters: GetNinjaOneOrganizationsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getNinjaOneOrganizations().'
            );
        }

        if (requestParameters['getNinjaOneOrganizationsRequest'] == null) {
            throw new runtime.RequiredError(
                'getNinjaOneOrganizationsRequest',
                'Required parameter "getNinjaOneOrganizationsRequest" was null or undefined when calling getNinjaOneOrganizations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/integrations/ninjaone/organizations`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetNinjaOneOrganizationsRequestToJSON(requestParameters['getNinjaOneOrganizationsRequest']),
        };
    }

    /**
     * Get NinjaOne organizations (cached). Optional credentials in the body allow loading before the config is saved.
     */
    async getNinjaOneOrganizationsRaw(requestParameters: GetNinjaOneOrganizationsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNinjaOneOrganizations200Response>> {
        const requestOptions = await this.getNinjaOneOrganizationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNinjaOneOrganizations200ResponseFromJSON(jsonValue));
    }

    /**
     * Get NinjaOne organizations (cached). Optional credentials in the body allow loading before the config is saved.
     */
    async getNinjaOneOrganizations(clientUUID: string, getNinjaOneOrganizationsRequest: GetNinjaOneOrganizationsRequest, refresh?: GetNinjaOneOrganizationsOperationRefreshEnum, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNinjaOneOrganizations200Response> {
        const response = await this.getNinjaOneOrganizationsRaw({ clientUUID: clientUUID, getNinjaOneOrganizationsRequest: getNinjaOneOrganizationsRequest, refresh: refresh }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getTehtrisStatuses without sending the request
     */
    async getTehtrisStatusesRequestOpts(requestParameters: GetTehtrisStatusesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling getTehtrisStatuses().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/integrations/tehtris/statuses`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Tehtris ticket statuses (cached)
     */
    async getTehtrisStatusesRaw(requestParameters: GetTehtrisStatusesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTehtrisStatuses200Response>> {
        const requestOptions = await this.getTehtrisStatusesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTehtrisStatuses200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Tehtris ticket statuses (cached)
     */
    async getTehtrisStatuses(clientUUID: string, refresh?: GetTehtrisStatusesRefreshEnum, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTehtrisStatuses200Response> {
        const response = await this.getTehtrisStatusesRaw({ clientUUID: clientUUID, refresh: refresh }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setIntegrationEnabled without sending the request
     */
    async setIntegrationEnabledRequestOpts(requestParameters: SetIntegrationEnabledOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling setIntegrationEnabled().'
            );
        }

        if (requestParameters['setIntegrationEnabledRequest'] == null) {
            throw new runtime.RequiredError(
                'setIntegrationEnabledRequest',
                'Required parameter "setIntegrationEnabledRequest" was null or undefined when calling setIntegrationEnabled().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/integrations/enabled`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetIntegrationEnabledRequestToJSON(requestParameters['setIntegrationEnabledRequest']),
        };
    }

    /**
     * Switch a configured integration on or off without touching the rest of its configuration
     */
    async setIntegrationEnabledRaw(requestParameters: SetIntegrationEnabledOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetIntegrationEnabled200Response>> {
        const requestOptions = await this.setIntegrationEnabledRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetIntegrationEnabled200ResponseFromJSON(jsonValue));
    }

    /**
     * Switch a configured integration on or off without touching the rest of its configuration
     */
    async setIntegrationEnabled(clientUUID: string, setIntegrationEnabledRequest: SetIntegrationEnabledRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetIntegrationEnabled200Response> {
        const response = await this.setIntegrationEnabledRaw({ clientUUID: clientUUID, setIntegrationEnabledRequest: setIntegrationEnabledRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for testAutotaskConnection without sending the request
     */
    async testAutotaskConnectionRequestOpts(requestParameters: TestAutotaskConnectionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling testAutotaskConnection().'
            );
        }

        if (requestParameters['testAutotaskConnectionRequest'] == null) {
            throw new runtime.RequiredError(
                'testAutotaskConnectionRequest',
                'Required parameter "testAutotaskConnectionRequest" was null or undefined when calling testAutotaskConnection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/integrations/autotask/test`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TestAutotaskConnectionRequestToJSON(requestParameters['testAutotaskConnectionRequest']),
        };
    }

    /**
     * Test the Autotask PSA connection
     */
    async testAutotaskConnectionRaw(requestParameters: TestAutotaskConnectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TestAutotaskConnection200Response>> {
        const requestOptions = await this.testAutotaskConnectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TestAutotaskConnection200ResponseFromJSON(jsonValue));
    }

    /**
     * Test the Autotask PSA connection
     */
    async testAutotaskConnection(clientUUID: string, testAutotaskConnectionRequest: TestAutotaskConnectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TestAutotaskConnection200Response> {
        const response = await this.testAutotaskConnectionRaw({ clientUUID: clientUUID, testAutotaskConnectionRequest: testAutotaskConnectionRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for testEmailForwarding without sending the request
     */
    async testEmailForwardingRequestOpts(requestParameters: TestEmailForwardingOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling testEmailForwarding().'
            );
        }

        if (requestParameters['testEmailForwardingRequest'] == null) {
            throw new runtime.RequiredError(
                'testEmailForwardingRequest',
                'Required parameter "testEmailForwardingRequest" was null or undefined when calling testEmailForwarding().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/integrations/email-forwarding/test`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TestEmailForwardingRequestToJSON(requestParameters['testEmailForwardingRequest']),
        };
    }

    /**
     * Send an email forwarding test mail to the configured target mailbox
     */
    async testEmailForwardingRaw(requestParameters: TestEmailForwardingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TestEmailForwarding200Response>> {
        const requestOptions = await this.testEmailForwardingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TestEmailForwarding200ResponseFromJSON(jsonValue));
    }

    /**
     * Send an email forwarding test mail to the configured target mailbox
     */
    async testEmailForwarding(clientUUID: string, testEmailForwardingRequest: TestEmailForwardingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TestEmailForwarding200Response> {
        const response = await this.testEmailForwardingRaw({ clientUUID: clientUUID, testEmailForwardingRequest: testEmailForwardingRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for testNinjaOneConnection without sending the request
     */
    async testNinjaOneConnectionRequestOpts(requestParameters: TestNinjaOneConnectionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling testNinjaOneConnection().'
            );
        }

        if (requestParameters['testNinjaOneConnectionRequest'] == null) {
            throw new runtime.RequiredError(
                'testNinjaOneConnectionRequest',
                'Required parameter "testNinjaOneConnectionRequest" was null or undefined when calling testNinjaOneConnection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/integrations/ninjaone/test`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TestNinjaOneConnectionRequestToJSON(requestParameters['testNinjaOneConnectionRequest']),
        };
    }

    /**
     * Test NinjaOne RMM connection
     */
    async testNinjaOneConnectionRaw(requestParameters: TestNinjaOneConnectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TestNinjaOneConnection200Response>> {
        const requestOptions = await this.testNinjaOneConnectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TestNinjaOneConnection200ResponseFromJSON(jsonValue));
    }

    /**
     * Test NinjaOne RMM connection
     */
    async testNinjaOneConnection(clientUUID: string, testNinjaOneConnectionRequest: TestNinjaOneConnectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TestNinjaOneConnection200Response> {
        const response = await this.testNinjaOneConnectionRaw({ clientUUID: clientUUID, testNinjaOneConnectionRequest: testNinjaOneConnectionRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for testTehtrisConnection without sending the request
     */
    async testTehtrisConnectionRequestOpts(requestParameters: TestTehtrisConnectionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling testTehtrisConnection().'
            );
        }

        if (requestParameters['testTehtrisConnectionRequest'] == null) {
            throw new runtime.RequiredError(
                'testTehtrisConnectionRequest',
                'Required parameter "testTehtrisConnectionRequest" was null or undefined when calling testTehtrisConnection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/integrations/tehtris/test`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TestTehtrisConnectionRequestToJSON(requestParameters['testTehtrisConnectionRequest']),
        };
    }

    /**
     * Test Tehtris XDR connection
     */
    async testTehtrisConnectionRaw(requestParameters: TestTehtrisConnectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TestTehtrisConnection200Response>> {
        const requestOptions = await this.testTehtrisConnectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TestTehtrisConnection200ResponseFromJSON(jsonValue));
    }

    /**
     * Test Tehtris XDR connection
     */
    async testTehtrisConnection(clientUUID: string, testTehtrisConnectionRequest: TestTehtrisConnectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TestTehtrisConnection200Response> {
        const response = await this.testTehtrisConnectionRaw({ clientUUID: clientUUID, testTehtrisConnectionRequest: testTehtrisConnectionRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateIntegrationsConfig without sending the request
     */
    async updateIntegrationsConfigRequestOpts(requestParameters: UpdateIntegrationsConfigOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling updateIntegrationsConfig().'
            );
        }

        if (requestParameters['updateIntegrationsConfigRequest'] == null) {
            throw new runtime.RequiredError(
                'updateIntegrationsConfigRequest',
                'Required parameter "updateIntegrationsConfigRequest" was null or undefined when calling updateIntegrationsConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/client/{clientUUID}/integrations/`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateIntegrationsConfigRequestToJSON(requestParameters['updateIntegrationsConfigRequest']),
        };
    }

    /**
     * Update integrations configuration for a client
     */
    async updateIntegrationsConfigRaw(requestParameters: UpdateIntegrationsConfigOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.updateIntegrationsConfigRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Update integrations configuration for a client
     */
    async updateIntegrationsConfig(clientUUID: string, updateIntegrationsConfigRequest: UpdateIntegrationsConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.updateIntegrationsConfigRaw({ clientUUID: clientUUID, updateIntegrationsConfigRequest: updateIntegrationsConfigRequest }, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetAutotaskCompaniesOperationRefreshEnum = {
    True: 'true',
    False: 'false',
} as const;
export type GetAutotaskCompaniesOperationRefreshEnum = typeof GetAutotaskCompaniesOperationRefreshEnum[keyof typeof GetAutotaskCompaniesOperationRefreshEnum];
/**
 * @export
 */
export const GetAutotaskTicketFieldsRefreshEnum = {
    True: 'true',
    False: 'false',
} as const;
export type GetAutotaskTicketFieldsRefreshEnum = typeof GetAutotaskTicketFieldsRefreshEnum[keyof typeof GetAutotaskTicketFieldsRefreshEnum];
/**
 * @export
 */
export const GetNinjaOneOrganizationsOperationRefreshEnum = {
    True: 'true',
    False: 'false',
} as const;
export type GetNinjaOneOrganizationsOperationRefreshEnum = typeof GetNinjaOneOrganizationsOperationRefreshEnum[keyof typeof GetNinjaOneOrganizationsOperationRefreshEnum];
/**
 * @export
 */
export const GetTehtrisStatusesRefreshEnum = {
    True: 'true',
    False: 'false',
} as const;
export type GetTehtrisStatusesRefreshEnum = typeof GetTehtrisStatusesRefreshEnum[keyof typeof GetTehtrisStatusesRefreshEnum];
